import React, { forwardRef } from 'react';
import { FormInput } from './FormInput';

const FormDateTimePicker = forwardRef(({ ...props }, ref) => {
    return (
        <FormInput
            ref={ref}
            type="datetime-local"
            {...props}
        />
    );
});

FormDateTimePicker.displayName = 'FormDateTimePicker';

export { FormDateTimePicker };
export default FormDateTimePicker;
